import styled from '@emotion/styled';

import { Message } from '@britishcouncil/react-extro-ui';

export const StyledPageContainer = styled.div`
    &&& {
        div[data-testid='page-container'] {
            padding: 0px;
            background-color: inherit;
        }
    }
`;

export const Header = styled.div`
  position: relative;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;

  span {
    font-family: BCSansHeading, Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 53px;
    color: #23085a;
  }

  &::after {
    content: '';
    width: 58px;
    height: 0px;
    border: 3px solid #23085a;
    border-radius: 12px;
    left: 0px;
    bottom: -20px;
    position: absolute;
  }
`;

export const ContentWrapper = styled.div`
  border-radius: 16px;
  background: #e7f0f7;
  padding: 20px;
  margin-top: 12px;
`;

export const StyledWarningMessage = styled(Message)`
  margin-bottom: 20px;
  ol li {
    list-style: list-item;
    list-style-position: inside;
  }

  svg > path {
    stroke: #23085a;
  }
`;
